import { JSONSchema7WithErrors } from '@cibo/core'
import { useConditionalValue } from './useConditionalValue'

export const useCiboAutoFormDisplays = ({
  schema,
  model,
}: {
  schema: {
    $defs?: Record<string, JSONSchema7WithErrors>
    'ui-params'?: any
    properties: Record<string, any>
  }
  model: any
}) => {
  const displays = useConditionalValue({
    schema,
    configPath: 'ui-params.displays',
    model,
  })

  return displays || Object.keys(schema.properties)
}
